//*************************************************************************************
//* WaMS Component Framework - app.fileUpload.js
//* Version 0.1
//* Author: Huisenga
//* Component framework file upload plugin
//* Requires jQuery, WaMS Component Framework, fine uploader
//*
//* Component tags file upload elements and intiailizes them using fine uploader
//*
//*************************************************************************************
//2/23/18 Huisenga    [STUDYAB-339]: Added Binding for edit mode complete

app.fileUploaders = (function () {
    var myUploaders = {
        Init: function () {
            this.initFileUploadComponents();
            this.setupEventDelegation();
        },

        // Set up event delegation for remove buttons
        setupEventDelegation: function () {
            // Remove any existing listeners to avoid duplicates
            document.removeEventListener('click', this.handleRemoveClick);

            // Add single event listener for all remove buttons
            document.addEventListener('click', this.handleRemoveClick.bind(this));
        },

        // Handle remove button clicks via event delegation
        handleRemoveClick: function (e) {
            if (e.target.matches('[data-uppy-remove]')) {
                e.preventDefault();

                const containerId = e.target.dataset.containerId;
                const fieldName = e.target.dataset.fieldName;
                const fileIndex = parseInt(e.target.dataset.fileIndex);

                this.removeUppyFileItem(containerId, fieldName, fileIndex);
            } else if (e.target.matches('[data-uppy-clear-all]')) {
                e.preventDefault();
                const containerId = e.target.dataset.containerId;
                const fieldName = e.target.dataset.fieldName;
                this.clearAllUppyFiles(containerId, fieldName);
            }
        },

        initFileUploadComponents: function () {
            const uploaders = document.querySelectorAll('[data-role="fileUploader"]');

            uploaders.forEach(wrapper => {
                const containerId = wrapper.getAttribute('data-container-id');
                const uploadUrl = wrapper.getAttribute('data-upload-url');
                const fieldName = wrapper.getAttribute('data-field-name');
                const maxFileSize = parseInt(wrapper.getAttribute('data-max-file-size')) || 10485760;
                const maxFiles = parseInt(wrapper.getAttribute('data-max-files')) || 1;
                const allowedFileTypesStr = wrapper.getAttribute('data-allowed-file-types');
                const isSingleFileModel = wrapper.getAttribute('data-single-file-model') === 'true';

                // Parse allowed file types
                let allowedFileTypes = null;
                if (allowedFileTypesStr && allowedFileTypesStr !== '*') {
                    allowedFileTypes = allowedFileTypesStr.split(',').map(type => type.trim());
                }

                const config = {
                    uploadUrl: uploadUrl,
                    fieldName: fieldName,
                    maxFileSize: maxFileSize,
                    maxFiles: maxFiles,
                    allowedFileTypes: allowedFileTypes,
                    isSingleFileModel: isSingleFileModel
                };

                this.initFileUploadComponent(containerId, config);
            });
        },

        initFileUploadComponent: function (containerId, config) {
            const { Uppy } = window;

            if (!Uppy) {
                console.error('Uppy is not loaded. Please include Uppy scripts.');
                return;
            }

            const container = document.getElementById(containerId);
            if (!container) {
                console.error(`Container with ID '${containerId}' not found.`);
                return;
            }

            // Skip if already initialized, or destroy existing instance if force reinit
            //if (container.uppyInstance) {
            //    console.log(`Uppy instance already exists for container '${containerId}'. Skipping initialization.`);
            //    return;
            //}

            const wrapper = container.closest('.uppy-wrapper');
            const fileDisplay = wrapper.querySelector('.uppy-file-display');
            const fileList = wrapper.querySelector('.uppy-file-list');
            const hiddenInputsContainer = wrapper.querySelector('.uppy-hidden-inputs');

            // Initialize Uppy
            const uppy = new Uppy.Uppy({
                id: containerId,
                restrictions: {
                    maxNumberOfFiles: config.maxFiles,
                    maxFileSize: config.maxFileSize,
                    allowedFileTypes: config.allowedFileTypes
                },
                autoProceed: true
            });

            // Add Dashboard plugin
            uppy.use(Uppy.Dashboard, {
                target: `#${containerId}`,
                inline: true,
                width: '100%',
                height: 100,
                hideUploadButton: true,
                hideRetryButton: true,
                hidePauseResumeButton: true,
                hideCancelButton: true,
                hideProgressAfterFinish: true,
                proudlyDisplayPoweredByUppy: false,
                showRemoveButtonAfterComplete: false,
                showProgressDetails: true,
                note: null
            });

            // Add XHR Upload plugin
            uppy.use(Uppy.XHRUpload, {
                endpoint: config.uploadUrl,
                method: 'POST',
                fieldName: 'file',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            // Handle successful upload
            uppy.on('upload-success', (file, response) => {
                const responseData = response.body;

                // Expect the server to return a DocumentViewModel structure
                const documentViewModel = {
                    id: responseData?.id || 0,
                    displayName: responseData?.displayName || file.name,
                    fileName: responseData?.fileName || file.name,
                    guid: responseData?.guid || '',
                    size: responseData?.size || file.size
                };

                if (documentViewModel.guid) {
                    // Get current file count to determine the index
                    const currentFileCount = fileList.children.length;

                    // Create new file item in the list
                    const fileItem = document.createElement('div');
                    fileItem.className = 'uppy-file-item';
                    fileItem.setAttribute('data-file-index', currentFileCount);
                    fileItem.setAttribute('data-file-guid', documentViewModel.guid);

                    // Format file size for display
                    let fileInfo = documentViewModel.displayName;
                    if (documentViewModel.size > 0) {
                        const sizeInKB = documentViewModel.size / 1024;
                        const sizeInMB = sizeInKB / 1024;
                        const sizeStr = sizeInMB >= 1 ? `${sizeInMB.toFixed(1)} MB` : `${sizeInKB.toFixed(0)} KB`;
                        fileInfo += ` (${sizeStr})`;
                    }

                    // Updated: Use data attributes instead of onclick
                    fileItem.innerHTML = `
                <div class="uppy-file-info">
                    <span class="uppy-file-name">${fileInfo}</span>
                    <span class="uppy-file-meta">${documentViewModel.fileName}</span>
                </div>
                <button type="button" 
                        class="uppy-remove-btn" 
                        data-uppy-remove="true"
                        data-container-id="${containerId}"
                        data-field-name="${config.fieldName}"
                        data-file-index="${currentFileCount}">
                    Remove
                </button>
            `;

                    // Add to file list
                    fileList.appendChild(fileItem);

                    // Create hidden inputs based on model type
                    let hiddenInputsHtml;
                    if (config.isSingleFileModel) {
                        // Generate non-indexed field names for single file binding
                        hiddenInputsHtml = `
                <input type="hidden" name="${config.fieldName}.Id" value="${documentViewModel.id}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}.DisplayName" value="${documentViewModel.displayName}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}.FileName" value="${documentViewModel.fileName}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}.Guid" value="${documentViewModel.guid}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}.Size" value="${documentViewModel.size}" data-file-index="${currentFileCount}" />
               `;
                    } else {
                        // Generate indexed field names for list binding
                        hiddenInputsHtml = `
                <input type="hidden" name="${config.fieldName}[${currentFileCount}].Id" value="${documentViewModel.id}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}[${currentFileCount}].DisplayName" value="${documentViewModel.displayName}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}[${currentFileCount}].FileName" value="${documentViewModel.fileName}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}[${currentFileCount}].Guid" value="${documentViewModel.guid}" data-file-index="${currentFileCount}" />
                <input type="hidden" name="${config.fieldName}[${currentFileCount}].Size" value="${documentViewModel.size}" data-file-index="${currentFileCount}" />
               `;
                    }

                    hiddenInputsContainer.insertAdjacentHTML('beforeend', hiddenInputsHtml);

                    // Show file display area
                    fileDisplay.style.display = 'block';

                    // Hide drop area if max files reached
                    const newFileCount = fileList.children.length;
                    if (config.maxFiles === 1 || newFileCount >= config.maxFiles) {
                        container.style.display = 'none';
                    }

                    // Reset uppy for next upload
                    uppy.removeFile(file.id);
                    //validate
                    this.triggerFileValidation(config.fieldName);
                }
            });

            // Handle upload errors
            uppy.on('upload-error', (file, error, response) => {
                console.error('Upload failed:', error);
                alert('Upload failed. Please try again.');
            });

            // Store uppy instance on the container for potential cleanup
            container.uppyInstance = uppy;
        },

        // Global function to remove a specific uploaded file by index
        removeUppyFileItem(containerId, fieldName, fileIndex) {
            const container = document.getElementById(containerId);
            const wrapper = container.closest('.uppy-wrapper');
            const fileDisplay = wrapper.querySelector('.uppy-file-display');
            const fileList = wrapper.querySelector('.uppy-file-list');
            const hiddenInputsContainer = wrapper.querySelector('.uppy-hidden-inputs');

            // Remove the file item from the list
            const fileItem = fileList.querySelector(`[data-file-index="${fileIndex}"]`);
            if (fileItem) {
                fileItem.remove();
            }

            // Remove the corresponding hidden inputs
            const hiddenInputs = hiddenInputsContainer.querySelectorAll(`[data-file-index="${fileIndex}"]`);
            hiddenInputs.forEach(input => input.remove());

            // Reindex remaining items and inputs
            this.reindexFileItems(fileList, hiddenInputsContainer, fieldName, containerId);

            // Show drop area if we're below max files
            const maxFiles = parseInt(wrapper.getAttribute('data-max-files')) || 1;
            const currentFileCount = fileList.children.length;
            if (currentFileCount < maxFiles) {
                container.style.display = 'block';
            }

            // Hide file display if no files remain
            if (currentFileCount === 0) {
                fileDisplay.style.display = 'none';
            }
            this.triggerFileValidation(fieldName);
        },

        // Helper function to reindex file items and hidden inputs after removal
        reindexFileItems(fileList, hiddenInputsContainer, fieldName, containerId) {
            // Get the wrapper to check if it's a single file model
            const container = document.getElementById(containerId);
            const wrapper = container.closest('[data-role="fileUploader"]');
            const isSingleFileModel = wrapper.getAttribute('data-single-file-model') === 'true';

            const fileItems = fileList.querySelectorAll('.uppy-file-item');
            const allHiddenInputs = hiddenInputsContainer.querySelectorAll('input[type="hidden"]');

            // Group hidden inputs by their current index
            const inputGroups = {};
            allHiddenInputs.forEach(input => {
                const currentIndex = input.getAttribute('data-file-index');
                if (!inputGroups[currentIndex]) {
                    inputGroups[currentIndex] = [];
                }
                inputGroups[currentIndex].push(input);
            });

            // Reindex file items and their corresponding inputs
            fileItems.forEach((fileItem, newIndex) => {
                const oldIndex = fileItem.getAttribute('data-file-index');
                fileItem.setAttribute('data-file-index', newIndex);

                // Update the remove button data attributes - much cleaner!
                const removeBtn = fileItem.querySelector('.uppy-remove-btn');
                if (removeBtn) {
                    removeBtn.setAttribute('data-file-index', newIndex);
                    // containerId and fieldName should already be correct from when button was created
                }

                // Update corresponding hidden inputs
                if (inputGroups[oldIndex]) {
                    inputGroups[oldIndex].forEach(input => {
                        input.setAttribute('data-file-index', newIndex);
                        // Update the name attribute to reflect new index
                        const nameAttr = input.getAttribute('name');
                        if (nameAttr) {
                            let newName;
                            if (isSingleFileModel) {
                                // For single file models, keep the non-indexed format
                                // Names should stay as fieldName.PropertyName
                                newName = nameAttr; // No change needed for single file
                            } else {
                                // For list models, update the index
                                newName = nameAttr.replace(/\[\d+\]/, `[${newIndex}]`);
                            }
                            input.setAttribute('name', newName);
                        }
                    });
                }
            });
        },

        // Global function to clear all uploaded files
        clearAllUppyFiles(containerId, fieldName) {
            const container = document.getElementById(containerId);
            const wrapper = container.closest('.uppy-wrapper');
            const fileDisplay = wrapper.querySelector('.uppy-file-display');
            const fileList = wrapper.querySelector('.uppy-file-list');
            const hiddenInputsContainer = wrapper.querySelector('.uppy-hidden-inputs');

            // Clear all file items
            fileList.innerHTML = '';

            // Clear all hidden inputs
            hiddenInputsContainer.innerHTML = '';

            // Show drop area and hide file display
            container.style.display = 'block';
            fileDisplay.style.display = 'none';

            // Reset uppy instance if it exists
            if (container.uppyInstance) {
                container.uppyInstance.clear();
            }
            this.triggerFileValidation(fieldName);
        },

        // Function to cleanup and destroy an Uppy instance
        destroyUppyInstance(containerId) {
            const container = document.getElementById(containerId);
            if (container && container.uppyInstance) {
                container.uppyInstance.close();
                delete container.uppyInstance;
                console.log(`Uppy instance destroyed for container '${containerId}'.`);
            }
        },

        // Function to force re-initialization of an uploader
        reinitializeUploader(containerId) {
            const container = document.getElementById(containerId);
            if (!container) return;

            const wrapper = container.closest('[data-role="fileUploader"]');
            if (!wrapper) return;

            // Destroy existing instance
            this.destroyUppyInstance(containerId);

            // Re-read configuration and initialize
            const uploadUrl = wrapper.getAttribute('data-upload-url');
            const fieldName = wrapper.getAttribute('data-field-name');
            const maxFileSize = parseInt(wrapper.getAttribute('data-max-file-size')) || 10485760;
            const maxFiles = parseInt(wrapper.getAttribute('data-max-files')) || 1;
            const allowedFileTypesStr = wrapper.getAttribute('data-allowed-file-types');
            const isSingleFileModel = wrapper.getAttribute('data-single-file-model') === 'true';

            let allowedFileTypes = null;
            if (allowedFileTypesStr && allowedFileTypesStr !== '*') {
                allowedFileTypes = allowedFileTypesStr.split(',').map(type => type.trim());
            }

            const config = {
                uploadUrl: uploadUrl,
                fieldName: fieldName,
                maxFileSize: maxFileSize,
                maxFiles: maxFiles,
                allowedFileTypes: allowedFileTypes,
                isSingleFileModel: isSingleFileModel
            };

            this.initFileUploadComponent(containerId, config);
        },
        triggerFileValidation(fieldName) {
            const validationInput = $(`input[name="${fieldName}"]`).filter('[data-val-requiredfile]');
            if (validationInput.length > 0) {
                // Trigger validation on the input
                validationInput.valid();
            }
        }
    };

    return myUploaders;
}());

$(document).ready(function () {
    app.fileUploaders.Init();
});